import type { SelectOption } from "./types";

export const OPTION_LISTS: Record<string, SelectOption[]> = {
	COUNTRIES_ISO: [
		{ value: "US", label: { en: "United States" } },
		{ value: "CA", label: { en: "Canada" } },
		{ value: "MX", label: { en: "Mexico" } },
		{ value: "GB", label: { en: "United Kingdom" } },
		{ value: "DE", label: { en: "Germany" } },
		{ value: "FR", label: { en: "France" } },
		{ value: "ES", label: { en: "Spain" } },
		{ value: "IT", label: { en: "Italy" } },
		{ value: "NL", label: { en: "Netherlands" } },
		{ value: "BE", label: { en: "Belgium" } },
		{ value: "CH", label: { en: "Switzerland" } },
		{ value: "AT", label: { en: "Austria" } },
		{ value: "SE", label: { en: "Sweden" } },
		{ value: "NO", label: { en: "Norway" } },
		{ value: "DK", label: { en: "Denmark" } },
		{ value: "FI", label: { en: "Finland" } },
		{ value: "PL", label: { en: "Poland" } },
		{ value: "PT", label: { en: "Portugal" } },
		{ value: "GR", label: { en: "Greece" } },
		{ value: "IE", label: { en: "Ireland" } },
		{ value: "CZ", label: { en: "Czech Republic" } },
		{ value: "HU", label: { en: "Hungary" } },
		{ value: "RO", label: { en: "Romania" } },
		{ value: "BG", label: { en: "Bulgaria" } },
		{ value: "HR", label: { en: "Croatia" } },
		{ value: "SK", label: { en: "Slovakia" } },
		{ value: "SI", label: { en: "Slovenia" } },
		{ value: "EE", label: { en: "Estonia" } },
		{ value: "LV", label: { en: "Latvia" } },
		{ value: "LT", label: { en: "Lithuania" } },
		{ value: "CY", label: { en: "Cyprus" } },
		{ value: "LU", label: { en: "Luxembourg" } },
		{ value: "MT", label: { en: "Malta" } },
		{ value: "UA", label: { en: "Ukraine" } },
		{ value: "RS", label: { en: "Serbia" } },
		{ value: "AL", label: { en: "Albania" } },
		{ value: "BA", label: { en: "Bosnia and Herzegovina" } },
		{ value: "ME", label: { en: "Montenegro" } },
		{ value: "MK", label: { en: "North Macedonia" } },
		{ value: "MD", label: { en: "Moldova" } },
		{ value: "GE", label: { en: "Georgia" } },
		{ value: "AM", label: { en: "Armenia" } },
		{ value: "AZ", label: { en: "Azerbaijan" } },
		{ value: "AU", label: { en: "Australia" } },
		{ value: "NZ", label: { en: "New Zealand" } },
		{ value: "JP", label: { en: "Japan" } },
		{ value: "KR", label: { en: "South Korea" } },
		{ value: "SG", label: { en: "Singapore" } },
		{ value: "HK", label: { en: "Hong Kong" } },
		{ value: "TW", label: { en: "Taiwan" } },
		{ value: "IN", label: { en: "India" } },
		{ value: "ID", label: { en: "Indonesia" } },
		{ value: "TH", label: { en: "Thailand" } },
		{ value: "MY", label: { en: "Malaysia" } },
		{ value: "PH", label: { en: "Philippines" } },
		{ value: "VN", label: { en: "Vietnam" } },
		{ value: "CN", label: { en: "China" } },
		{ value: "KZ", label: { en: "Kazakhstan" } },
		{ value: "UZ", label: { en: "Uzbekistan" } },
		{ value: "KG", label: { en: "Kyrgyzstan" } },
		{ value: "TJ", label: { en: "Tajikistan" } },
		{ value: "MN", label: { en: "Mongolia" } },
		{ value: "BR", label: { en: "Brazil" } },
		{ value: "AR", label: { en: "Argentina" } },
		{ value: "CL", label: { en: "Chile" } },
		{ value: "CO", label: { en: "Colombia" } },
		{ value: "PE", label: { en: "Peru" } },
		{ value: "VE", label: { en: "Venezuela" } },
		{ value: "EC", label: { en: "Ecuador" } },
		{ value: "UY", label: { en: "Uruguay" } },
		{ value: "PY", label: { en: "Paraguay" } },
		{ value: "BO", label: { en: "Bolivia" } },
		{ value: "CR", label: { en: "Costa Rica" } },
		{ value: "PA", label: { en: "Panama" } },
		{ value: "GT", label: { en: "Guatemala" } },
		{ value: "HN", label: { en: "Honduras" } },
		{ value: "SV", label: { en: "El Salvador" } },
		{ value: "DO", label: { en: "Dominican Republic" } },
		{ value: "JM", label: { en: "Jamaica" } },
		{ value: "TT", label: { en: "Trinidad and Tobago" } },
		{ value: "BS", label: { en: "Bahamas" } },
		{ value: "ZA", label: { en: "South Africa" } },
		{ value: "NG", label: { en: "Nigeria" } },
		{ value: "KE", label: { en: "Kenya" } },
		{ value: "EG", label: { en: "Egypt" } },
		{ value: "MA", label: { en: "Morocco" } },
		{ value: "GH", label: { en: "Ghana" } },
		{ value: "ET", label: { en: "Ethiopia" } },
		{ value: "TZ", label: { en: "Tanzania" } },
		{ value: "UG", label: { en: "Uganda" } },
		{ value: "SN", label: { en: "Senegal" } },
		{ value: "CI", label: { en: "Ivory Coast" } },
		{ value: "RW", label: { en: "Rwanda" } },
		{ value: "AO", label: { en: "Angola" } },
		{ value: "MZ", label: { en: "Mozambique" } },
		{ value: "MU", label: { en: "Mauritius" } },
		{ value: "BW", label: { en: "Botswana" } },
		{ value: "CM", label: { en: "Cameroon" } },
		{ value: "ZM", label: { en: "Zambia" } },
		{ value: "NA", label: { en: "Namibia" } },
		{ value: "MW", label: { en: "Malawi" } },
		{ value: "DZ", label: { en: "Algeria" } },
		{ value: "TN", label: { en: "Tunisia" } },
		{ value: "AE", label: { en: "United Arab Emirates" } },
		{ value: "SA", label: { en: "Saudi Arabia" } },
		{ value: "QA", label: { en: "Qatar" } },
		{ value: "KW", label: { en: "Kuwait" } },
		{ value: "BH", label: { en: "Bahrain" } },
		{ value: "OM", label: { en: "Oman" } },
		{ value: "JO", label: { en: "Jordan" } },
		{ value: "LB", label: { en: "Lebanon" } },
		{ value: "IQ", label: { en: "Iraq" } },
		{ value: "IL", label: { en: "Israel" } },
		{ value: "TR", label: { en: "Turkey" } },
		{ value: "PK", label: { en: "Pakistan" } },
		{ value: "BD", label: { en: "Bangladesh" } },
		{ value: "LK", label: { en: "Sri Lanka" } },
		{ value: "NP", label: { en: "Nepal" } },
		{ value: "MM", label: { en: "Myanmar" } },
		{ value: "KH", label: { en: "Cambodia" } },
		{ value: "LA", label: { en: "Laos" } },
	],

	ENTITY_TYPES_GENERIC: [
		{ value: "LLC", label: { en: "LLC" } },
		{ value: "Corporation", label: { en: "Corporation" } },
		{ value: "Partnership", label: { en: "Partnership" } },
		{ value: "Sole Proprietorship", label: { en: "Sole Proprietorship" } },
		{ value: "Trust", label: { en: "Trust" } },
		{ value: "Other", label: { en: "Other" } },
	],

	WALLET_TYPES: [
		{ value: "Custodial", label: { en: "Custodial" } },
		{ value: "Non-Custodial", label: { en: "Non-Custodial" } },
		{ value: "Hybrid", label: { en: "Hybrid" } },
	],

	HOSTED_STATUS: [
		{ value: "Hosted", label: { en: "Hosted" } },
		{ value: "Un-hosted", label: { en: "Un-hosted" } },
		{ value: "Hybrid", label: { en: "Hybrid" } },
	],

	PUBLIC_KEY_SHARING: [
		{ value: "Individual", label: { en: "Individual" } },
		{ value: "Organization", label: { en: "Organization" } },
		{ value: "Both", label: { en: "Both" } },
	],

	OWNER_TYPES: [
		{ value: "Individual", label: { en: "Individual" } },
		{ value: "Corporation", label: { en: "Corporation" } },
	],
};

/** Map from display name (legacy) to ISO alpha-2 code */
export const DISPLAY_TO_ISO: Record<string, string> = {
	"United States": "US",
	Canada: "CA",
	Mexico: "MX",
	"United Kingdom": "GB",
	Germany: "DE",
	France: "FR",
	Spain: "ES",
	Italy: "IT",
	Netherlands: "NL",
	Belgium: "BE",
	Switzerland: "CH",
	Austria: "AT",
	Sweden: "SE",
	Norway: "NO",
	Denmark: "DK",
	Finland: "FI",
	Poland: "PL",
	Portugal: "PT",
	Greece: "GR",
	Ireland: "IE",
	"Czech Republic": "CZ",
	Hungary: "HU",
	Romania: "RO",
	Bulgaria: "BG",
	Croatia: "HR",
	Slovakia: "SK",
	Slovenia: "SI",
	Estonia: "EE",
	Latvia: "LV",
	Lithuania: "LT",
	Cyprus: "CY",
	Luxembourg: "LU",
	Malta: "MT",
	Ukraine: "UA",
	Serbia: "RS",
	Albania: "AL",
	"Bosnia and Herzegovina": "BA",
	Montenegro: "ME",
	"North Macedonia": "MK",
	Moldova: "MD",
	Georgia: "GE",
	Armenia: "AM",
	Azerbaijan: "AZ",
	Australia: "AU",
	"New Zealand": "NZ",
	Japan: "JP",
	"South Korea": "KR",
	Singapore: "SG",
	"Hong Kong": "HK",
	Taiwan: "TW",
	India: "IN",
	Indonesia: "ID",
	Thailand: "TH",
	Malaysia: "MY",
	Philippines: "PH",
	Vietnam: "VN",
	China: "CN",
	Kazakhstan: "KZ",
	Uzbekistan: "UZ",
	Kyrgyzstan: "KG",
	Tajikistan: "TJ",
	Mongolia: "MN",
	Brazil: "BR",
	Argentina: "AR",
	Chile: "CL",
	Colombia: "CO",
	Peru: "PE",
	Venezuela: "VE",
	Ecuador: "EC",
	Uruguay: "UY",
	Paraguay: "PY",
	Bolivia: "BO",
	"Costa Rica": "CR",
	Panama: "PA",
	Guatemala: "GT",
	Honduras: "HN",
	"El Salvador": "SV",
	"Dominican Republic": "DO",
	Jamaica: "JM",
	"Trinidad and Tobago": "TT",
	Bahamas: "BS",
	"South Africa": "ZA",
	Nigeria: "NG",
	Kenya: "KE",
	Egypt: "EG",
	Morocco: "MA",
	Ghana: "GH",
	Ethiopia: "ET",
	Tanzania: "TZ",
	Uganda: "UG",
	Senegal: "SN",
	"Ivory Coast": "CI",
	Rwanda: "RW",
	Angola: "AO",
	Mozambique: "MZ",
	Mauritius: "MU",
	Botswana: "BW",
	Cameroon: "CM",
	Zambia: "ZM",
	Namibia: "NA",
	Malawi: "MW",
	Algeria: "DZ",
	Tunisia: "TN",
	"United Arab Emirates": "AE",
	"Saudi Arabia": "SA",
	Qatar: "QA",
	Kuwait: "KW",
	Bahrain: "BH",
	Oman: "OM",
	Jordan: "JO",
	Lebanon: "LB",
	Iraq: "IQ",
	Israel: "IL",
	Turkey: "TR",
	Pakistan: "PK",
	Bangladesh: "BD",
	"Sri Lanka": "LK",
	Nepal: "NP",
	Myanmar: "MM",
	Cambodia: "KH",
	Laos: "LA",
};

/**
 * Normalize a country value to ISO alpha-2.
 * If already a 2-letter code, return as-is (uppercased).
 * Otherwise attempt lookup in DISPLAY_TO_ISO; fall back to raw value.
 */
export function normalizeCountry(raw: string | undefined): string {
	if (!raw) return "";
	const trimmed = raw.trim();
	if (trimmed.length === 2) return trimmed.toUpperCase();
	return DISPLAY_TO_ISO[trimmed] ?? trimmed;
}
